import React, { useEffect, useState } from 'react';

const gradeOptions = [
  'Kindergarten',
  '1st Grade',
  '2nd Grade',
  '3rd Grade',
  '4th Grade',
  '5th Grade'
];

const LeaderboardPage = () => {
  const [topTen, setTopTen] = useState([]);
  const [gradeTotals, setGradeTotals] = useState([]);

  useEffect(() => {
    // Fetch both the leaderboard donation data and all teachers
    Promise.all([
      fetch('https://server-ojqx.onrender.com/api/donations/leaderboard').then(res => res.json()),
      fetch('https://server-ojqx.onrender.com/api/teachers').then(res => res.json())
    ])
      .then(([donationData, teachers]) => {

        // Combine donation totals with teacher info (add $0 for missing)
        const donationMap = {};
        donationData.forEach(entry => {
          donationMap[entry.teacherId] = entry.total;
        });

        const combinedData = teachers.map(teacher => ({
          teacherId: teacher._id,
          teacherName: teacher.name,
          grade: teacher.grade,
          total: donationMap[teacher._id] || 0
        }));

        const sortedByTotal = [...combinedData].sort((a, b) => b.total - a.total);
        setTopTen(sortedByTotal.slice(0, 10));

        // Grade-level totals
        const totalsMap = {};
        for (const grade of gradeOptions) {
          totalsMap[grade] = 0;
        }

        for (const entry of combinedData) {
          if (totalsMap[entry.grade] !== undefined) {
            totalsMap[entry.grade] += entry.total;
          }
        }

        const totalsArray = Object.entries(totalsMap).map(([grade, total]) => ({
          grade,
          total
        }));

        totalsArray.sort((a, b) => b.total - a.total);
        setGradeTotals(totalsArray);
      })
      .catch(err => console.error('Error loading leaderboard:', err));
  }, []);

  const renderTable = (data, title) => (
    <>
      <h3>{title}</h3>
      <table>
        <thead>
          <tr>
            <th>Teacher</th>
            <th>Grade</th>
            <th>Total Raised ($)</th>
          </tr>
        </thead>
        <tbody>
          {data.map(entry => (
            <tr key={entry.teacherId}>
              <td>{entry.teacherName}</td>
              <td>{entry.grade}</td>
              <td>{(entry.total / 100).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );

  const renderGradeTotalsTable = () => (
    <>
      <h3> Total Raised by Grade</h3>
      <table>
        <thead>
          <tr>
            <th>Grade</th>
            <th>Total Raised ($)</th>
          </tr>
        </thead>
        <tbody>
          {gradeTotals.map((g, idx) => (
            <tr key={idx}>
              <td>{g.grade}</td>
              <td>{(g.total / 100).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );

  return (
    <div>
      <h2>Leaderboard</h2>

      {renderGradeTotalsTable()}
      {renderTable(topTen, 'Top 10 Classes')}
    </div>
  );
};

export default LeaderboardPage;